import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ProcessSchema, ProcessCategorySchema } from '../../entities/process/process.schema';
import { ErrorCode } from '../../shared/error-codes';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/**
 * Add Process Request Schema
 * POST /api/v2/process
 * Creates a new process with specified owner, department, and details
 */ export const AddProcessRequestSchema = z.object({
    owner: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    accountable: ObjectIdSchema.or(z.literal('')).optional(),
    department: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    name: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    description: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    apqcEquivalentId: z.string().optional(),
    // TODO: Review AI Code for feature: Process Map
    category: ProcessCategorySchema.nullable().optional()
});
/**
 * Add Process Response Schema
 * Returned on successful process creation
 * Contains the created process object
 */ export const AddProcessResponseSchema = z.object({
    process: ProcessSchema
});
/**
 * Add Process Error Schema
 * Returned when process creation fails
 */ export const AddProcessErrorSchema = BaseErrorSchema;

//# sourceMappingURL=add-process.schema.js.map